import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import {
  Container,
  Divider,
  ElsaHomePage,
  ElsaProgrammes,
  Spacer,
} from "ui-start";
import { PartnerLogos } from "../components/PartnerLogos";
import { Header } from "../components/Header";
import { siteColors } from "../variables/colors";

// eslint-disable-next-line
export const IndexPageTemplate = ({ images }) => {
  return (
    <div className="home-page">
      <Spacer height={8} />
      <ElsaHomePage />
      <Container center>
        <Container maxWidth="1200px">
          <Spacer height={32} />
          <Divider color="#999" />
          <Spacer height={32} />
          <Container center>
            <Header color={siteColors.purple}>ELSA PROGRAMMES</Header>
          </Container>
          <ElsaProgrammes />
          <Spacer height={60} />
          <Divider color="#999" />
        </Container>
      </Container>
      <Spacer height={40} />
      <PartnerLogos images={images} />
    </div>
  );
};

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        subheading={frontmatter.intro.heading}
        description={frontmatter.intro.description}
        intro={frontmatter.intro}
        images={frontmatter.intro.logos}
      />
    </Layout>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH)
          }
        }
        heading
        subheading
        description
        intro {
          logos {
            image {
              publicURL
            }
          }
          heading
          description
        }
      }
    }
  }
`;
